import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

export const FeeRecommendationChangeType = {
  ADD: 'Add',
  EDIT: 'Edit',
  REMOVE: 'Remove',
};

export const FeeRecommendationItemStatus = {
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
  SUPERSEDED: 'Superseded',
};

const FeeRecommendationSessionStatus = {
  PENDING: 'Pending',
  PARTIALLY_REVIEWED: 'PartiallyReviewed',
  FULLY_REVIEWED: 'FullyReviewed',
};

export const FEE_RECOMMENDATION_CHANGE_TYPE_DISPLAY = {
  [FeeRecommendationChangeType.ADD]: { label: 'New fee', variant: LabelVariant.BLUE },
  [FeeRecommendationChangeType.EDIT]: { label: 'Edit', variant: LabelVariant.ORANGE },
  [FeeRecommendationChangeType.REMOVE]: { label: 'Remove', variant: LabelVariant.RED },
};

export const FEE_RECOMMENDATION_ITEM_STATUS_DISPLAY = {
  [FeeRecommendationItemStatus.PENDING]: { label: 'Pending', variant: LabelVariant.GRAY },
  [FeeRecommendationItemStatus.ACCEPTED]: { label: 'Accepted', variant: LabelVariant.GREEN },
  [FeeRecommendationItemStatus.REJECTED]: { label: 'Rejected', variant: LabelVariant.RED },
  [FeeRecommendationItemStatus.SUPERSEDED]: { label: 'Replaced', variant: LabelVariant.GRAY },
};

// LEN-137: the title agent submitted this session from suggestions an AI process drafted for them.
export const FeeRecommendationSource = {
  TITLE_PORTAL: 'TitlePortal',
  AI_PROCESS: 'AiProcess',
};

export const AI_ASSISTED_SESSION_DISPLAY = {
  label: 'AI-assisted',
  variant: LabelVariant.PURPLE,
};

export const SUPERSEDED_SESSION_DISPLAY = {
  label: 'Replaced by a newer submission',
  variant: LabelVariant.GRAY,
};

export const FEE_RECOMMENDATION_SESSION_STATUS_DISPLAY = {
  [FeeRecommendationSessionStatus.PENDING]: { label: 'Pending review', variant: LabelVariant.GRAY },
  [FeeRecommendationSessionStatus.PARTIALLY_REVIEWED]: {
    label: 'Partially reviewed',
    variant: LabelVariant.ORANGE,
  },
  [FeeRecommendationSessionStatus.FULLY_REVIEWED]: {
    label: 'Fully reviewed',
    variant: LabelVariant.GREEN,
  },
};

export const FEE_RECOMMENDATION_AMOUNT_FIELDS = [
  {
    label: 'Borrower at closing',
    proposedKey: 'borrowerAtClosing',
    originalKey: 'originalBorrowerAtClosing',
  },
  {
    label: 'Borrower before closing',
    proposedKey: 'borrowerBeforeClosing',
    originalKey: 'originalBorrowerBeforeClosing',
  },
  {
    label: 'Seller at closing',
    proposedKey: 'sellerAtClosing',
    originalKey: 'originalSellerAtClosing',
  },
  {
    label: 'Seller before closing',
    proposedKey: 'sellerBeforeClosing',
    originalKey: 'originalSellerBeforeClosing',
  },
  {
    label: 'Paid by others',
    proposedKey: 'paidByOthers',
    originalKey: 'originalPaidByOthers',
  },
  {
    label: 'Financed',
    proposedKey: 'financedAmount',
    originalKey: 'originalFinancedAmount',
  },
];

export const NO_AMOUNT_LABEL = '—';
export const UNKNOWN_FEE_LABEL = 'Unknown fee';
export const REMOVAL_PROPOSED_LABEL = 'Proposed removal of this fee.';
